export default "/_next/static/images/48cc61cbad837b20cc6cbf8b1420fdfd.png";